export default "__VITE_ASSET__CDbQ91R8__"